import { observer } from 'mobx-react-lite';

import { XStack } from '@/components/ui';
import { TranscriptionInputDeviceDropdown } from '@/features/transcription-input-device';

import {
  ACTIVE_MEETING_INPUT_DEVICE_CONFIG,
  MEETING_PREFERENCE_INPUT_DEVICE_CONFIG,
} from '../meetings-transcription-input-device.config';
import { meetingStore } from '../meetings.state';

import { CopyTranscriptButton } from './CopyTranscriptButton';
import { TranscriptGotoButton } from './TranscriptGotoButton';

import type { Meeting } from '../meetings.types';

interface HeadingProps {
  isInPopup?: boolean;
  meeting: Pick<Meeting, 'id' | 'name'>;
}

export const TranscriptHeading = observer(
  ({ isInPopup, meeting }: HeadingProps) => {
    const isRecordingThisMeeting = meetingStore.isMeetingIdRecording(
      meeting.id
    );
    const meetingInViewId = meetingStore.meetingInViewId;
    const shouldShowMeetingName =
      isRecordingThisMeeting && meetingInViewId !== meeting.id;

    return (
      <>
        {isInPopup && (
          <XStack className="items-center justify-between px-3 py-1.5">
            <XStack className="items-center gap-1">
              {shouldShowMeetingName && (
                <TranscriptGotoButton meetingId={meeting.id} />
              )}
            </XStack>
            <XStack className="items-center gap-2">
              <TranscriptionInputDeviceDropdown
                size="default"
                variant="compact"
                config={
                  isRecordingThisMeeting
                    ? ACTIVE_MEETING_INPUT_DEVICE_CONFIG
                    : MEETING_PREFERENCE_INPUT_DEVICE_CONFIG
                }
              />
              <CopyTranscriptButton meetingId={meeting.id} />
            </XStack>
          </XStack>
        )}
      </>
    );
  }
);
